import { useMemo, useCallback } from "react";
import debounce from "lodash/debounce";
import Button from "@mui/material/Button";
import ButtonGroup from "@mui/material/ButtonGroup";

interface EmployeeCountProps {
	employeeCount: number;
	setEmployeeCount: React.Dispatch<React.SetStateAction<number>>;
	handleEmployeeCountChange: (value: number) => void;
}

export const EmployeeCount = ({ employeeCount, setEmployeeCount, handleEmployeeCountChange }: EmployeeCountProps) => {
	const changeCount = useCallback(
		(value: number) => {
			handleEmployeeCountChange(value);
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[]
	);

	const setEmployeeCountDebounce = useMemo(() => debounce(changeCount, 1000), [changeCount]);

	const handleIncrement = () => {
		setEmployeeCount((prevCount) => {
			let newCount = Number(prevCount) + 1;
			setEmployeeCountDebounce(newCount);
			return newCount;
		});
	};

	const handleDecrement = () => {
		setEmployeeCount((prevCount) => {
			let newCount = Number(prevCount) - 1 < 0 ? 0 : Number(prevCount) - 1;
			setEmployeeCountDebounce(newCount);
			return newCount;
		});
	};

	return (
		<ButtonGroup aria-label="Employee Count" fullWidth sx={{ paddingTop: "1vh" }}>
			<Button variant="outlined" color="secondary" onClick={handleDecrement} className="employeeBtn">
				-
			</Button>
			<Button variant="outlined" color="secondary" className="employeeBtn" disabled>
				{employeeCount}
			</Button>
			<Button variant="outlined" color="secondary" onClick={handleIncrement} className="employeeBtn">
				+
			</Button>
		</ButtonGroup>
	);
};

export default EmployeeCount;
